<template>
  <v-container fluid class="pa-6 mt-n6">
    <!-- Header Moderno -->
    <v-row align="center" justify="space-between" class="mb-0">
            <v-col cols="12" md="auto" class="mt-0 pt-0">
            <div class="d-flex align-center justify-center">
              <v-avatar color="primary" size="52" class="mr-3 elevation-2">
                <v-icon color="white" size="28">request_quote</v-icon>
              </v-avatar>
              <div>
                <div class="text-h5 font-weight-bold grey--text text--darken-2">Facturas de Venta</div>
                <div class="text-caption grey--text">  Gestión y control de facturas</div>
              </div>
            </div>
          </v-col>
      <v-col cols="auto" v-if="totalItems > 0">
        <v-chip color="grey lighten-4" class="px-5 py-5">
          <v-icon left color="primary">mdi-file-document-multiple</v-icon>
          <span class="font-weight-bold grey--text text--darken-2">{{ totalItems }}</span>
          <span class="ml-1 grey--text text--darken-1">facturas</span>
        </v-chip>
      </v-col>
    </v-row>


    <!-- Filtros Principales -->
    <v-card class="mb-4 elevation-1" outlined>
      <v-card-text class="pb-2">
        <v-row align="center" class="mb-0">
          <v-col md="2" sm="6" cols="12">
            <v-autocomplete v-model="business_filter" outlined dense :disabled="loading" hide-details
              :items="itemsBussines" label="Unidad de Negocio" prepend-inner-icon="mdi-domain"></v-autocomplete>
          </v-col>

          <v-col md="2" sm="6" cols="12">
            <v-autocomplete v-model="location_filter" outlined dense :disabled="loading" hide-details :items="locations"
              label="Ubicación" prepend-inner-icon="mdi-map-marker"></v-autocomplete>
          </v-col>

          <v-col md="2" sm="6" cols="12">
            <v-select v-model="rangeSelected_filter" outlined dense :disabled="loading" hide-details :items="dateRanges"
              label="Rango de Fechas" prepend-inner-icon="mdi-calendar-range"></v-select>
          </v-col>
          <v-col md="4" sm="12" cols="12" v-if="rangeSelected_filter == '7'">
            <v-row no-gutters>
              <v-col cols="6" class="pr-1">
                <v-menu v-model="menu_dateStart_filter" :close-on-content-click="false" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="dateStart_filterDMY" label="Desde" readonly v-bind="attrs" v-on="on" outlined
                      dense :disabled="loading" hide-details prepend-inner-icon="mdi-calendar-start"></v-text-field>
                  </template>
                  <v-date-picker v-model="dateStart_filter" @input="menu_dateStart_filter = false;" locale="es"
                    color="primary"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6" class="pl-1">
                <v-menu v-model="menu_dateEnd_filter" :close-on-content-click="false" transition="scale-transition"
                  offset-y min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field :value="dateEnd_filterDMY" label="Hasta" readonly v-bind="attrs" v-on="on" outlined
                      dense :disabled="loading" hide-details prepend-inner-icon="mdi-calendar-end"></v-text-field>
                  </template>
                  <v-date-picker v-model="dateEnd_filter" @input="menu_dateEnd_filter = false;" locale="es"
                    color="primary"></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-col>

          <v-col md="2" sm="6" cols="12" class="d-flex align-center">
            <v-btn color="primary" @click="loadAllData('b')" :disabled="loading" depressed block class="text-none">
              <v-icon left>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- Filtros Secundarios -->
    <v-card class="mb-4 elevation-1" outlined>
      <v-card-text class="pb-2">
        <v-row align="center">
          <v-col md="2" sm="6" cols="12">
            <v-autocomplete v-model="invoice_type" outlined dense :disabled="loading" hide-details :items="[
              { value: 0, text: 'Todo' },
              { value: 2, text: 'Venta directa' },
              { value: 5, text: 'Vouchers / credito empleado' },
              { value: 8, text: 'Bonos' },
            ]" label="Tipo de factura" prepend-inner-icon="mdi-file-document"></v-autocomplete>
          </v-col>

          <v-col md="2" sm="6" cols="12">
            <v-autocomplete v-model="invoice_category" outlined dense :disabled="loading" hide-details
              :items="item_categories" label="Categoría" prepend-inner-icon="mdi-tag"></v-autocomplete>
          </v-col>

          <v-col md="2" sm="6" cols="12">
            <v-autocomplete v-model="currency_filter" outlined dense :disabled="loading" hide-details :items="[
              { value: 0, text: 'Todas' },
              { value: 1, text: 'DOP' },
              { value: 2, text: 'HTG' },
              { value: 3, text: 'USD' },
              { value: 4, text: 'EUR' },
            ]" label="Moneda" prepend-inner-icon="mdi-currency-usd"></v-autocomplete>
          </v-col>

          <v-col md="2" sm="6" cols="12">
            <v-autocomplete v-model="box_filter" outlined dense :disabled="loading" hide-details :items="boxFilterList"
              label="Caja" prepend-inner-icon="mdi-cash-register"></v-autocomplete>
          </v-col>

          <v-col md="2" sm="6" cols="12">
            <v-autocomplete v-model="customer_filter" outlined dense :disabled="loading" hide-details
              :items="customerFilterList" label="Cliente" prepend-inner-icon="mdi-account"></v-autocomplete>
          </v-col>

          <v-col md="2" sm="6" cols="12">
            <v-row no-gutters align="center">
              <v-col cols="10">
                <v-autocomplete v-model="branche_filter" outlined dense :disabled="customer_filter < 0 || loading"
                  hide-details :items="brancheFilterList" label="Sucursal"
                  prepend-inner-icon="mdi-store"></v-autocomplete>
              </v-col>
              <v-col cols="2" class="pl-1">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="clearUiFilters" :disabled="loading" v-bind="attrs" v-on="on" color="grey">
                      <v-icon>mdi-filter-off</v-icon>
                    </v-btn>
                  </template>
                  <span>Limpiar filtros</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- Tabla de Facturas -->
    <v-card class="elevation-1 mb-4" outlined>
      <!-- <v-row v-if="loading" justify="center">
                  <v-col cols="12" md="10">
                    <v-skeleton-loader
                      type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
                    >
                    </v-skeleton-loader>
                  </v-col>
                </v-row> -->
      <v-data-table :headers="tableHeaders" :items="invoices" :loading="loading" :search="search"
        :server-items-length="totalItems" :options.sync="options" :items-per-page.sync="itemsPerPage"
        class="elevation-0 modern-table" dense height="57vh" fixed-header hide-default-footer>
        <template v-slot:top>
          <v-sheet class="pa-4" color="grey lighten-5">
            <v-row align="center">
              <!-- Estadísticas -->
              <v-col cols="auto">
                <div class="d-flex align-center">
                  <div class="mr-3">
                    <v-chip color="success" outlined small class="px-3">
                      <v-icon left x-small color="success">mdi-check-circle</v-icon>
                      <span class="font-weight-medium">{{ invoices_count(1) }}</span>
                      <span class="ml-1 text-caption grey--text">Activas</span>
                    </v-chip>
                  </div>
                  <div>
                    <v-chip color="error" outlined small class="px-3">
                      <v-icon left x-small color="error">mdi-close-circle</v-icon>
                      <span class="font-weight-medium">{{ invoices_count(2) }}</span>
                      <span class="ml-1 text-caption grey--text">Anuladas</span>
                    </v-chip>
                  </div>
                </div>
              </v-col>

              <!-- Selección para impresión en lote -->
              <v-col cols="auto" v-if="selectMode">
                <div class="d-flex align-center selection-bar rounded-lg px-3 py-1">
                  <v-icon small color="primary" class="mr-2">mdi-checkbox-multiple-marked-outline</v-icon>
                  <span class="text-body-2 font-weight-medium primary--text">
                    {{ selectedInvoices.length }} seleccionada{{ selectedInvoices.length === 1 ? "" : "s" }}
                  </span>
                  <v-btn color="primary" depressed x-small class="ml-3 text-none" :disabled="selectedInvoices.length === 0"
                    @click="printSelected">
                    <v-icon left x-small>mdi-printer-outline</v-icon>
                    Imprimir
                  </v-btn>
                  <v-btn v-if="selectedInvoices.length > 0" text x-small color="grey darken-1" class="ml-1 text-none"
                    @click="clearSelection">
                    Limpiar
                  </v-btn>
                  <v-btn icon x-small class="ml-1" title="Salir de selección" @click="exitSelectMode">
                    <v-icon x-small>mdi-close</v-icon>
                  </v-btn>
                </div>
              </v-col>

              <v-spacer></v-spacer>

              <!-- Acciones -->
              <v-col cols="auto">
                <v-btn v-if="!selectMode" color="grey darken-1" outlined small class="mr-2 text-none"
                  @click="selectMode = true">
                  <v-icon left small>mdi-checkbox-multiple-outline</v-icon>
                  Seleccionar
                </v-btn>

                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="grey darken-1" outlined small v-bind="attrs" v-on="on" class="mr-2 text-none">
                      <v-icon left small>mdi-download</v-icon>
                      Exportar
                      <v-icon right x-small>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="save_csv(1)">
                      <v-list-item-icon>
                        <v-icon color="success">mdi-file-excel</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Excel Detallado</v-list-item-title>
                        <v-list-item-subtitle class="text-caption">Incluye todos los campos</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="save_csv(2)">
                      <v-list-item-icon>
                        <v-icon color="success">mdi-file-excel</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Excel Agrupado</v-list-item-title>
                        <v-list-item-subtitle class="text-caption">Resumen por categoría</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-list-item @click="save_csv(3)">
                      <v-list-item-icon>
                        <v-icon color="error">mdi-file-excel</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>Facturas Canceladas</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider></v-divider>
                    <v-list-item @click="downloadPDF" disabled>
                      <v-list-item-icon>
                        <v-icon color="grey">mdi-file-pdf-box</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>PDF</v-list-item-title>
                        <v-list-item-subtitle class="text-caption">Próximamente</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <v-btn v-if="$store.state.auth.globalFeatures.includes('ING-025')" color="primary" @click="showNew"
                  depressed small class="mr-2 text-none">
                  <v-icon left small>mdi-plus</v-icon>
                  Nueva Factura
                </v-btn>

                <v-badge :value="user_group.length > 0" color="error" :content="user_group.length" overlap>
                  <v-btn icon small @click="loadUserFilters" :loading="loading_search_invoice" color="grey darken-1">
                    <v-icon small>mdi-tune</v-icon>
                  </v-btn>
                </v-badge>
              </v-col>
            </v-row>
          </v-sheet>
        </template>
        <template v-slot:[`header.select`]>
          <v-simple-checkbox :value="pageSelectionState === 'all'" :indeterminate="pageSelectionState === 'some'"
            :disabled="selectableOnPage.length === 0" color="primary" @input="togglePageSelection"></v-simple-checkbox>
        </template>
        <template v-slot:[`item.select`]="{ item }">
          <v-simple-checkbox :value="selectedInvoices.includes(item.invoice_id)" :disabled="item.status_id != 1"
            color="primary" @input="toggleInvoiceSelection(item)"></v-simple-checkbox>
        </template>
        <template v-slot:[`item.invoice_number`]="{ item }">
          <v-hover v-slot="{ hover }">
            <span @click="showInvoice(item.invoice_id, true)"
              class="primary--text font-weight-normal text-truncate font-weight-semibold" :style="{
                color: hover ? 'red' : 'black',
                cursor: hover ? 'pointer' : '',
                'text-decoration': hover ? 'underline' : '',
              }">
              <span class="red--text d-flex" v-if="item.invoice_type_id == 5"> </span>

              {{ item.invoice_number }}

              <v-icon v-if="item.box_id > 0">mdi-point-of-sale</v-icon>
              <br />
              {{ item.invoice_ncf }}
            </span>
          </v-hover>
          <br />
        </template>
        <template v-slot:[`item.total_amount`]="{ item }">
          <span>
            {{ currencyFormat(item.total_amount) }} {{ item.currency_code }}
          </span>
        </template>
        <template v-slot:[`item.total_paid`]="{ item }">
          <span>
            {{ currencyFormat(item.total_paid) }} {{ item.currency_code }}
          </span>
        </template>
        <template v-slot:[`item.pending_amount`]="{ item }">
          <span>
            {{ currencyFormat(item.pending_amount) }} {{ item.currency_code }}
          </span>
        </template>
        <template v-slot:[`item.entity_name`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-hover v-slot="{ hover }">
                <span @click="viewEntity(item.entity_id)" style="font-size: 14px"
                  class="primary--text font-weight-normal text-truncate font-weight-semibold" :style="{
                    color: hover ? 'red' : 'black',
                    cursor: hover ? 'pointer' : '',
                    'text-decoration': hover ? 'underline' : '',
                  }" v-bind="attrs" v-on="on">
                  {{ item.entity_name.slice(0, 15) }}...
                </span>
              </v-hover>
            </template>

            <span>{{ item.entity_name }}</span>
          </v-tooltip>
        </template>
        <template v-slot:[`item.dgii_status`]="{ item }">
          <div v-if="item.invoice_ncf">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip small v-bind="attrs" v-on="on" :color="item.dgii_status === 'ACEPTADO' ? 'primary' : 'grey'"
                  :dark="item.dgii_status === 'ACEPTADO'" :outlined="item.dgii_status !== 'ACEPTADO'"
                  class="px-3 dgii-chip font-weight-bold" :class="item.dgii_status === 'ACEPTADO' ? 'elevation-4' : ''">
                  <v-icon small color="white" left>
                    {{ item.dgii_status === 'ACEPTADO'
                      ? 'mdi-shield-check'
                      : 'mdi-shield-alert'
                    }}
                  </v-icon>
                  {{ item.dgii_status === 'ACEPTADO' ? 'DGII ✓' : 'Sin Validar' }}
                </v-chip>
              </template>

              <div class="pa-2">
                <div class="d-flex align-center mb-2">
                  <v-icon :color="item.dgii_status === 'ACEPTADO' ? 'success' : 'warning'" class="mr-2">
                    {{ item.dgii_status === 'ACEPTADO'
                      ? 'mdi-check-circle'
                      : 'mdi-information'
                    }}
                  </v-icon>
                  <span class="font-weight-bold">
                    {{ item.dgii_status === 'ACEPTADO'
                      ? 'Factura Aprobada por DGII'
                      : 'Sin Verificación DGII'
                    }}
                  </span>
                </div>
                <v-divider class="my-2"></v-divider>
                <div class="text-caption">
                  <strong>NCF:</strong> {{ item.invoice_ncf }}<br />
                  <strong>Estado:</strong> {{ item.dgii_status || 'Pendiente' }}
                </div>
              </div>
            </v-tooltip>
          </div>

          <v-chip v-else small outlined color="grey" class="px-2">
            <v-icon small color="grey" left>mdi-minus</v-icon>
            N/A
          </v-chip>
        </template>
        <template v-slot:[`item.status_id`]="{ item }">
          <v-chip x-small outlined color="success" v-if="item.status_id == 1" class="px-2">
            <v-icon color="success" v-if="item.recorded" x-small left>mdi-check</v-icon>
            <v-icon x-small left :color="item.invoice_type_id != 5 ? 'warning' : 'grey lighten-1'" v-else>{{
              item.invoice_type_id == 5 ? "mdi-block-helper" : "mdi-alert" }}</v-icon>
            Activa
          </v-chip>
          <v-chip x-small outlined color="error" v-else class="px-2">
            <v-icon x-small left>mdi-close</v-icon>
            Anulada
          </v-chip>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="
                item.status_id === 1 &&
                item.invoice_type_id !== 5 &&
                item.invoice_type_id !== 8 &&
                hasFeature('ING-025')
              " v-bind="attrs" v-on="on" color="primary" @click="editItem(item, true)" large>
                read_more
              </v-icon>
            </template>
            <span>Copiar</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="
                !item.recorded &&
                item.status_id == 1 &&
                !item.invoice_ncf?.startsWith('E') &&
                hasFeature('ING-026')
              " v-bind="attrs" v-on="on" medium color="warning" class="mx-1"
                @click="editItem(item, false)">edit</v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-row justify="center" class="pt-10">
            <v-icon size="80px">token</v-icon>
          </v-row>
          <v-row justify="center" class="pb-6"> No hay datos </v-row>
        </template>

        <template v-slot:footer>
          <v-divider></v-divider>
          <div class="pa-4">
            <v-row justify="center" align="center">
              <v-col cols="auto">
                <v-pagination v-model="currentPage" :length="pageCount" :total-visible="7" color="primary" circle
                  prev-icon="mdi-chevron-left" next-icon="mdi-chevron-right"></v-pagination>
              </v-col>
            </v-row>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <!-- Totales por Moneda -->
    <v-row class="mb-4">
      <v-col md="4" sm="6" cols="12" v-for="currency in currencyTotals" :key="currency.currency_code" v-show="!loadingTotals">
        <v-card class="currency-card elevation-1" outlined>
          <v-card-text class="pa-4">
            <v-row align="center" no-gutters>
              <v-col cols="auto" class="mr-4">
                <v-avatar size="56" :color="getCurrencyColor(currency.currency_code)" class="elevation-2">
                  <v-icon color="white" size="28">
                    {{ getCurrencyIcon(currency.currency_code) }}
                  </v-icon>
                </v-avatar>
              </v-col>
              <v-col>
                <p class="text-caption grey--text text--darken-1 mb-1">
                  Total {{ currency.currency_code }}
                </p>
                <h2 class="text-h5 font-weight-bold grey--text text--darken-3 mb-0">
                  {{ currencyFormat(currency.total_amount) }}
                </h2>
                <!-- <div class="d-flex align-center mt-1">
                  <v-icon x-small :color="currency.total_pending > 0 ? 'warning' : 'success'" class="mr-1">
                    {{ currency.total_pending > 0 ? 'mdi-clock-alert' : 'mdi-check-circle' }}
                  </v-icon>
                  <span class="text-caption grey--text">
                    Pendiente: {{ currencyFormat(currency.total_pending) }}
                  </span>
                </div> -->
              </v-col>
            </v-row>

            <!-- Progress bar -->
            <v-progress-linear
              :value="currency.total_amount > 0 ? ((currency.total_amount - currency.total_pending) / currency.total_amount) * 100 : 0"
              :color="getCurrencyColor(currency.currency_code)" background-color="grey lighten-3" height="4" rounded
              class="mt-3"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- Totales por Caja -->
    <v-card class="elevation-1 mb-4" v-if="boxCurrencyTotals.length > 0" outlined v-show="!loadingBoxTotals">
      <v-card-title class="grey lighten-5 py-3">
        <v-icon left color="primary">mdi-cash-register</v-icon>
        <span class="text-subtitle-1 font-weight-medium">Totales por Caja</span>
        <v-spacer></v-spacer>
        <v-chip small color="grey lighten-3" class="px-3">
          <v-icon small left>mdi-cash-multiple</v-icon>
          {{ Object.keys(groupedBoxTotals).length }} cajas
        </v-chip>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pa-4">
        <v-row>
          <v-col v-for="(currencies, boxName) in groupedBoxTotals" :key="boxName" cols="12" md="6" lg="4">
            <v-card class="elevation-2 box-card" outlined>
              <v-card-title class="pb-2 pt-3 px-4 grey lighten-5">
                <v-icon color="primary" class="mr-2">mdi-cash-register</v-icon>
                <span class="text-subtitle-2 font-weight-bold">{{ boxName }}</span>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text class="pa-3">
                <v-list dense class="transparent">
                  <v-list-item v-for="currency in currencies" :key="currency.currency_code" class="px-2 mb-1">
                    <v-list-item-avatar size="36" :color="getCurrencyColor(currency.currency_code)" class="mr-3">
                      <v-icon small color="white">{{ getCurrencyIcon(currency.currency_code) }}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-subtitle class="text-caption grey--text text--darken-1 mb-1">
                        {{ currency.currency_code }}
                      </v-list-item-subtitle>
                      <v-list-item-title class="text-h6 font-weight-bold"
                        :style="{ color: getCurrencyColor(currency.currency_code) }">
                        {{ currencyFormat(currency.total) }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- -----dialogo de edicion de facturas-------->
    <v-dialog transition="slide-x-transition" v-model="dialog" fullscreen persistent>
      <v-card style="background-color: #f4f5fa">
        <v-row justify="center">
          <v-col cols="12" md="12" lg="12" xl="12">
            <invoice v-if="dialog" :type="2" :editOrCopy="editedItem" :itbis="itbis" :credit_days="credit_days"
              :ncfTypes="ncfTypes" :withholdings="withholdings" :boxes="boxes" :accounts="accounts"
              :itemsLocations="itemsLocations" :invoice_categories="invoice_categories"
              :itemsDepartments="itemsDepartments" :editOrCopyStatus="editOrCopyStatus" @close-dialog="clear()"
              @save-invoice="save($event)" />
          </v-col>
        </v-row>

        <v-card-text> </v-card-text>
      </v-card>
    </v-dialog>
    <!-- ============ DIALOG OTROS FILTROS ============ -->
    <v-dialog v-model="dialog_settings" width="900" scrollable persistent>
      <v-card class="rounded-lg">
        <v-toolbar flat dense color="primary" dark>
          <v-icon left small>mdi-filter-variant</v-icon>
          <v-toolbar-title class="text-body-1 font-weight-bold">Filtros y búsqueda de ventas</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon small @click="cancel_user_filters()">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-0" style="max-height: 75vh;">
          <!-- ===== Sección: Agrupar por usuarios ===== -->
          <div class="px-5 py-4">
            <div class="d-flex align-center mb-2">
              <v-icon small color="grey darken-1" class="mr-2">mdi-account-group-outline</v-icon>
              <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2">Agrupar por usuarios</span>
              <v-spacer></v-spacer>
              <v-chip v-if="user_group.length > 0" x-small label color="primary lighten-5" text-color="primary">
                {{ user_group.length }} seleccionado(s)
              </v-chip>
            </div>
            <v-autocomplete
              v-model="user_group"
              outlined multiple dense chips small-chips deletable-chips
              hide-details
              no-data-text="No hay usuarios disponibles"
              :items="users"
              label="Usuarios"
              prepend-inner-icon="mdi-account-multiple"
              clearable
            ></v-autocomplete>
          </div>

          <v-divider></v-divider>

          <!-- ===== Sección: Búsqueda de facturas ===== -->
          <div class="px-5 py-4">
            <div class="d-flex align-center mb-2">
              <v-icon small color="grey darken-1" class="mr-2">mdi-magnify</v-icon>
              <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2">Buscar factura de venta</span>
              <v-spacer></v-spacer>
              <v-btn v-if="invoices_found.length > 0 || search_invoice || search_invoice_with_ncf"
                x-small text color="grey darken-1" @click="clearInvoiceSearch">
                <v-icon left x-small>mdi-broom</v-icon> Limpiar
              </v-btn>
            </div>
            <div class="text-caption grey--text mb-2">
              <v-icon x-small class="mr-1">mdi-information-outline</v-icon>
              Busca por número de factura interno o por el comprobante fiscal (NCF/eNCF). La búsqueda es flexible (ILIKE).
            </div>
            <v-alert v-if="!business_filter || business_filter === 0" type="warning" dense text border="left" class="mb-3 text-caption">
              <v-icon left x-small>mdi-alert</v-icon>
              <strong>Selecciona una Unidad de Negocio</strong> en los filtros principales antes de buscar. Cada unidad emite su propia secuencia de NCF, así que sin esto pueden aparecer facturas duplicadas de unidades distintas.
            </v-alert>
            <v-alert v-else type="info" dense text border="left" class="mb-3 text-caption">
              <v-icon left x-small>mdi-domain</v-icon>
              Buscando en: <strong>{{ currentBusinessUnitName }}</strong>
            </v-alert>

            <v-row dense>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="search_invoice"
                  label="Número de factura"
                  placeholder="Ej: FV0010000123"
                  prepend-inner-icon="mdi-receipt-text"
                  v-on:keyup.enter="find_invoice(1)"
                  @input="onSearchInputChange('invoice')"
                  dense outlined hide-details
                  :disabled="loading_search_invoice"
                  :loading="loading_search_invoice"
                  clearable
                  append-icon="mdi-magnify"
                  @click:append="find_invoice(1)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="search_invoice_with_ncf"
                  label="Comprobante / NCF"
                  placeholder="Ej: E310000000123 o B0100000123"
                  prepend-inner-icon="mdi-file-certificate"
                  v-on:keyup.enter="find_invoice(2)"
                  @input="onSearchInputChange('ncf')"
                  dense outlined hide-details
                  :disabled="loading_search_invoice"
                  :loading="loading_search_invoice"
                  clearable
                  append-icon="mdi-magnify"
                  @click:append="find_invoice(2)"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Tabla de resultados -->
            <div v-if="invoices_found.length > 0" class="mt-4">
              <div class="d-flex align-center mb-2">
                <v-chip x-small label color="success lighten-5" text-color="success" class="font-weight-bold">
                  <v-icon left x-small>mdi-check-circle</v-icon>
                  {{ invoices_found.length }} resultado(s)
                </v-chip>
              </div>
              <v-simple-table dense class="rounded-lg" style="border: 1px solid #e0e0e0;">
                <template v-slot:default>
                  <thead>
                    <tr style="background-color: #f5f7fa">
                      <th class="text-left" style="font-size: 11px;">Factura</th>
                      <th class="text-left" style="font-size: 11px;">NCF / Comprobante</th>
                      <th class="text-left" style="font-size: 11px;">Fecha</th>
                      <th class="text-left" style="font-size: 11px;">Cliente</th>
                      <th class="text-right" style="font-size: 11px;">Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in invoices_found" :key="item.invoice_id" dense>
                      <td>
                        <v-hover v-slot="{ hover }">
                          <span @click="showInvoice(item.invoice_id, true); dialog_settings = false"
                            class="primary--text font-weight-medium" :style="{
                              color: hover ? '#1976d2' : '#1565c0',
                              cursor: 'pointer',
                              'text-decoration': hover ? 'underline' : 'none',
                            }">
                            {{ item.invoice_number }}
                          </span>
                        </v-hover>
                      </td>
                      <td class="text-caption">
                        <v-chip
                          v-if="item.invoice_ncf"
                          x-small label
                          :color="item.invoice_ncf.startsWith('E') ? 'orange lighten-5' : 'blue lighten-5'"
                          :text-color="item.invoice_ncf.startsWith('E') ? 'orange darken-2' : 'blue darken-2'"
                        >
                          {{ item.invoice_ncf }}
                        </v-chip>
                        <span v-else class="grey--text">-</span>
                      </td>
                      <td class="text-caption">{{ item.emission_date }}</td>
                      <td class="text-caption">{{ item.entity_name }}</td>
                      <td class="text-right font-weight-bold">{{ currencyFormat(item.total_amount) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Empty state -->
            <v-card
              v-else-if="!loading_search_invoice && !search_invoice && !search_invoice_with_ncf"
              flat color="grey lighten-5" class="mt-4 pa-4 text-center rounded-lg"
            >
              <v-icon size="36" color="grey lighten-1">mdi-file-search-outline</v-icon>
              <div class="text-caption grey--text mt-2">Ingresa un criterio de búsqueda</div>
            </v-card>

            <!-- Loading state -->
            <v-card v-else-if="loading_search_invoice" flat class="mt-4 pa-4 text-center">
              <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
              <div class="text-caption grey--text mt-2">Buscando...</div>
            </v-card>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-5 py-3">
          <v-btn text small color="grey darken-1" @click="cancel_user_filters()">
            <v-icon left small>mdi-close</v-icon> Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" depressed @click="loadAllData('d7'), (dialog_settings = false)">
            <v-icon left small>mdi-check</v-icon> Aplicar filtros
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";

const BATCH_PRINT_MAX = 100;
const BATCH_PRINT_STORAGE_KEY = "invoice_sales_batch_print";

export default {
  data: () => ({
    loading: false,
    isInitializing: true,
    dialog_settings: false,
    loading_search_invoice: false,
    search_invoice: null,
    search_invoice_with_ncf: null,
    dialog: false,
    editedItem: null,
    invoices: [],
    itemsDepartments: [],
    itbis: [],
    credit_days: [],
    totalItems: 0,
    search: null,
    invoice_counts: [],
    selectMode: false, // muestra la columna de checkboxes
    selectedInvoices: [], // invoice_id en orden de selección (impresión en lote)
    invoices_found: [],
    boxFilterList: [],
    lastFilters: {},
    itemsPerPage: 10,
    lastPaginationOptions: {},
    customerFilterList: [],
    brancheFilterList: [],
    loadingCustomers: false,
    loadingTotals: false,
    boxCurrencyTotals: [],
    loadingBoxTotals: false,
    item_categories: [
      { value: 0, text: "Todo" },
      { value: 1, text: "Contado/efectivo" },
      { value: 2, text: "Credito" },
    ],
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    currencyTotals: [],
    business_filter: 0,
    location_filter: 0,
    dateStart_filter: moment().startOf("month").format("YYYY-MM-DD"),
    dateEnd_filter: moment().endOf("month").format("YYYY-MM-DD"),
    menu_dateStart_filter: false,
    menu_dateEnd_filter: false,
    rangeSelected_filter: "4", // Default: Este mes
    itemsBussines: [],
    locations: [],
    dateRanges: [
      { text: "Hoy", value: "1" },
      //{ text: "Ayer", value: "2" },
      { text: "Esta semana", value: "3" },
      { text: "Este mes", value: "4" },
      { text: "Ultimos 3 meses", value: "5" },
      { text: "Este año", value: "6" },
      { text: "Personalizado", value: "7" },
    ],
    currency_filter: 0,
    box_filter: 0,
    loading_box_filter: false,
    customer_filter: 0,
    branche_filter: -1,
    invoice_type: 0,
    invoice_category: 0,
    invoice_categories: null,
    user_group: [],
    users: [],
    itemsLocations: [],
    accounts: [],
    boxes: [],
    withholdings: [],
    ncfTypes: [],
    headers: [
      { text: "", value: "select", sortable: false, width: "36px" },
      { text: "Factura", align: "start", value: "invoice_number" },
      { text: "Caja", value: "box_name", cellClass: "text-caption" },
      { text: "Fecha", value: "emission_date", cellClass: "text-caption" },
      { text: "Cliente", value: "entity_name" },
      { text: "Sucursal", value: "branch", cellClass: "text-caption" },
      { text: "Total", value: "total_amount", align: "end", width: "8%" },
      // { text: "Notas", value: "total_notes", align: "end", width: "8%" },
      // { text: "Pago", value: "total_paid", align: " d-none", },
      // { text: "Pendiente", value: "pending_amount", align: "end" },
      { text: "DGII", value: "dgii_status", align: "center", width: "8%" },
      { text: "Estatus", value: "status_id", align: "center" },
      { text: "Actions", value: "actions" },
    ],
  }),
  computed: {
    tableHeaders() {
      return this.selectMode ? this.headers : this.headers.filter((h) => h.value !== "select");
    },
    selectableOnPage() {
      return (this.invoices || []).filter((i) => i.status_id == 1).map((i) => i.invoice_id);
    },
    pageSelectionState() {
      const selected = this.selectableOnPage.filter((id) => this.selectedInvoices.includes(id)).length;
      if (selected === 0) return "none";
      return selected === this.selectableOnPage.length ? "all" : "some";
    },
    currentBusinessUnitName() {
      if (!this.business_filter || this.business_filter === 0) return "Todas las unidades";
      const bu = (this.itemsBussines || []).find((b) => b.value === this.business_filter);
      return bu ? (bu.text || bu.description_long || bu.name || `Unidad #${this.business_filter}`) : `Unidad #${this.business_filter}`;
    },
    dateStart_filterDMY() {
      return moment(this.dateStart_filter).format("DD/MM/YYYY");
    },
    dateEnd_filterDMY() {
      return moment(this.dateEnd_filter).format("DD/MM/YYYY");
    },
    pageCount() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    currentPage: {
      get() {
        return this.options.page;
      },
      set(value) {
        this.options.page = value;
      },
    },
    groupedBoxTotals() {
      const grouped = {};

      this.boxCurrencyTotals.forEach(item => {
        if (!grouped[item.box_name]) {
          grouped[item.box_name] = [];
        }
        grouped[item.box_name].push({
          currency_code: item.currency_code,
          total: item.total
        });
      });

      return grouped;
    },
  },
  watch: {
    selectedInvoices(value) {
      sessionStorage.setItem(BATCH_PRINT_STORAGE_KEY, JSON.stringify(value));
    },
    user_group(newValue, oldValue) {
      this.options.page = 1;
    },
    options: {
      handler(newOptions) {
        const oldPage = this.lastPaginationOptions.page || 1;
        const oldItemsPerPage = this.lastPaginationOptions.itemsPerPage || 50;
        const pageChanged = newOptions.page !== oldPage;
        const itemsPerPageChanged = newOptions.itemsPerPage !== oldItemsPerPage;
        const sortChanged = JSON.stringify(newOptions.sortBy) !== JSON.stringify(this.lastPaginationOptions.sortBy);

        if (pageChanged || itemsPerPageChanged || sortChanged) {
          if (Object.keys(this.lastFilters).length > 0) {
            this.$store.commit('setInvoiceSalesFilter', { key: 'page', value: pageChanged });
            this.updateUrl(); // Actualizar URL antes de cargar
            this.loadInvoicesPaginada('c');
          }
        }
      },
      deep: true,
    },

    //  WATCHERS DE FILTROS MAESTROS (Dispararán loadAllData)
    business_filter(newValue, oldValue) {
      if (!this.isInitializing && newValue !== oldValue && newValue != null) {
        this.updateLocationsForBusiness();
        this.updateUrlAndLoadData();
        if (newValue != 0) {
          this.$store.commit("setBusiness", newValue);
        }
      }
    },
    location_filter(newValue, oldValue) {
      if (!this.isInitializing && newValue !== oldValue && newValue != null) {
        this.updateUrlAndLoadData();
        if (newValue != 0) {
          this.$store.commit("setLocation", newValue);
        }
      }
    },
    dateStart_filter(newValue, oldValue) {
      if (!this.isInitializing && newValue !== oldValue && this.rangeSelected_filter === "7") {
        // Solo recargar si el rango es "Personalizado"
        const isValid = moment(newValue, "YYYY-MM-DD", true).isValid();
        if (isValid) {
          this.syncStoreDateRange(newValue, this.dateEnd_filter);
          this.updateUrlAndLoadData();
        }
      }

    },
    dateEnd_filter(newValue, oldValue) {
      if (!this.isInitializing && newValue !== oldValue && this.rangeSelected_filter === "7") {
        // Solo recargar si el rango es "Personalizado"
        const isValid = moment(newValue, "YYYY-MM-DD", true).isValid();

        if (isValid) {
          this.syncStoreDateRange(this.dateStart_filter, newValue);
          this.updateUrlAndLoadData();
        }
      }
    },
    rangeSelected_filter(newValue, oldValue) {
      if (!this.isInitializing && newValue !== oldValue && newValue != null) {
        this.$store.commit("setRangeSelected", newValue);
        this.applyRangeDates(newValue);
        if (newValue != '7') {
          this.updateUrlAndLoadData();
        } else {
          this.syncStoreDateRange();
        }
      }
    },
    //  WATCHERS DE FILTROS DE UI (Dispararán handleFilterUIChange)
    customer_filter(newValue, oldValue) {
      if (newValue !== oldValue && newValue != null && Object.keys(this.lastFilters).length > 0) {
        this.$store.commit('setInvoiceSalesFilter', { key: 'customer', value: newValue });
        this.getBranchFilters(this.collectMasterFilters(), newValue);
        this.updateUrl();
        this.handleFilterUIChange();
      }
    },
    currency_filter(newValue, oldValue) {
      if (newValue !== oldValue && newValue != null && Object.keys(this.lastFilters).length > 0) {
        this.$store.commit('setInvoiceSalesFilter', { key: 'currency', value: newValue });
        this.loadAllData('d1');
        this.updateUrl();
      }
    },
    box_filter(newValue, oldValue) {
      if (newValue !== oldValue && newValue != null && Object.keys(this.lastFilters).length > 0) {
        this.$store.commit('setInvoiceSalesFilter', { key: 'box', value: newValue });
        this.loadAllData('d2');
        this.updateUrl();
      }
    },
    invoice_type(newValue, oldValue) {
      if (newValue !== oldValue && newValue != null && Object.keys(this.lastFilters).length > 0) {
        this.$store.commit('setInvoiceSalesFilter', { key: 'type', value: newValue });
        this.loadAllData('d3');
        this.updateUrl();
      }
    },
    invoice_category(newValue, oldValue) {
      if (newValue !== oldValue && newValue != null && Object.keys(this.lastFilters).length > 0) {
        this.$store.commit('setInvoiceSalesFilter', { key: 'category', value: newValue });
        this.loadAllData('d4');
        this.updateUrl();
      }
    },
    branche_filter(newValue, oldValue) {
      if (newValue !== oldValue && newValue != null && Object.keys(this.lastFilters).length > 0) {
        this.$store.commit('setInvoiceSalesFilter', { key: 'branch', value: newValue });
        this.updateUrl();
        this.handleFilterUIChange();
      }
    },
  },
  created() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(BATCH_PRINT_STORAGE_KEY) || "[]");
      if (Array.isArray(saved)) this.selectedInvoices = saved.filter(Number.isInteger);
      // Al volver de la impresión con una selección guardada, se mantiene el modo selección.
      this.selectMode = this.selectedInvoices.length > 0;
    } catch (e) {
      sessionStorage.removeItem(BATCH_PRINT_STORAGE_KEY);
    }
    this.itemsBussines = [...(this.$store.state.auth.bussines_units || [])];
    this.itemsBussines.unshift({ text: "Todas", value: 0 });
    this.updateLocationsForBusiness();
    // 1. URL (Prioridad Máxima)
    const { filtersFoundInUrl } = this.loadFiltersFromUrl();
    // 2. STORE (Si la URL no tenía filtros, revisar Store)
    if (!filtersFoundInUrl) {
      this.initializeFiltersFromStore();
    }
    // 3. Aplicar rango si se inicializó con uno (para ajustar las fechas)
    this.applyRangeDates(this.rangeSelected_filter, true);

    // 4. Cargar datos
    //this.loadAllData('d5');
    this.get_init_inputs();
    this.isInitializing = false;
  },
  methods: {
    // Impresión en lote
    toggleInvoiceSelection(item) {
      if (item.status_id != 1) return;
      const index = this.selectedInvoices.indexOf(item.invoice_id);
      if (index >= 0) {
        this.selectedInvoices.splice(index, 1);
      } else if (this.selectedInvoices.length >= BATCH_PRINT_MAX) {
        this.$toast.warning(`Máximo ${BATCH_PRINT_MAX} facturas por impresión`);
      } else {
        this.selectedInvoices.push(item.invoice_id);
      }
    },
    togglePageSelection() {
      if (this.pageSelectionState === "all") {
        this.selectedInvoices = this.selectedInvoices.filter((id) => !this.selectableOnPage.includes(id));
        return;
      }
      const toAdd = this.selectableOnPage.filter((id) => !this.selectedInvoices.includes(id));
      const room = BATCH_PRINT_MAX - this.selectedInvoices.length;
      if (toAdd.length > room) {
        this.$toast.warning(`Máximo ${BATCH_PRINT_MAX} facturas por impresión`);
      }
      this.selectedInvoices.push(...toAdd.slice(0, Math.max(room, 0)));
    },
    clearSelection() {
      this.selectedInvoices = [];
    },
    exitSelectMode() {
      this.selectedInvoices = [];
      this.selectMode = false;
    },
    printSelected() {
      if (this.selectedInvoices.length === 0) return;
      this.$router.push({
        name: "DownloadInvoicesBatch",
        query: { ids: this.selectedInvoices.join(",") },
      });
    },
    // Métodos para estilizar cards de monedas
    getCurrencyGradient(code) {
      // Usar colores del tema de Vuetify
      const primary = this.$vuetify.theme.currentTheme.primary;
      const secondary = this.$vuetify.theme.currentTheme.secondary;
      const success = this.$vuetify.theme.currentTheme.success;
      const info = this.$vuetify.theme.currentTheme.info;

      const gradients = {
        'DOP': `linear-gradient(135deg, ${primary} 0%, ${secondary || primary} 100%)`,
        'USD': `linear-gradient(135deg, ${success} 0%, #38ef7d 100%)`,
        'EUR': `linear-gradient(135deg, ${info} 0%, #00d4ff 100%)`,
        'HTG': `linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)`
      };
      return gradients[code] || `linear-gradient(135deg, ${primary} 0%, ${secondary || primary} 100%)`;
    },

    getCurrencyIcon(code) {
      const icons = {
        'DOP': 'mdi-currency-usd',
        'USD': 'mdi-currency-usd',
        'EUR': 'mdi-currency-eur',
        'HTG': 'mdi-cash-multiple'
      };
      return icons[code] || 'mdi-cash';
    },

    getCurrencyColor(code) {
      // Usar colores del tema de Vuetify
      const primary = this.$vuetify.theme.currentTheme.primary;
      const success = this.$vuetify.theme.currentTheme.success;
      const info = this.$vuetify.theme.currentTheme.info;

      const colors = {
        'DOP': primary,
        'USD': success,
        'EUR': info,
        'HTG': '#4facfe'
      };
      return colors[code] || primary;
    },

    async get_init_inputs() {
      const result = await Promise.all([
        this.api_Get("accounting/taxes"),
        this.api_Get("accounting/accountsUsable"),
        this.api_Get("humanResource/locations"),
        this.api_Get("income/boxes"),
        this.api_Get("accounting/withholdings"),
        this.api_Get("income/invoice_categories"),
        this.api_Get("accounting/nfc_types"),
        this.api_Get("accounting/credit_days"),

        this.g_departments(),
      ]);

      this.itbis = await result[0].json();

      for (let item of await result[1].json()) {
        this.accounts.push({
          text: item.code + " - " + item.name,
          value: item.id,
          id: item.id,
          dgii_category_id: item.dgii_category_id,
        });
      }
      for (let item of await result[2].json()) {
        for (let item2 of this.$store.state.auth.locations) {
          if (item2.id == item.id) {
            this.itemsLocations.push({
              value: item.id,
              text: item.desc_loc_long,
              id: item.id,
              bus_id: item.bus_id,
              desc_bus_short: item.desc_bus_short,
              desc_bus_long: item.desc_bus_long,
              desc_loc_short: item.desc_loc_short,
              desc_loc_long: item.desc_loc_long,
              city_id: item.city_id,
              city_description: item.city_description,
              location_adress: item.location_adress,
              status_id: item.status_id,
              catalogue_id: item.catalogue_id,
              catalogue_name: item.catalogue_name,
              rnl: item.rnl,
              representative_name: item.representative_name,
              sta_description: item.sta_description,
              employee_representative_id: item.employee_representative_id,
            });
          }
        }
      }
      this.boxes = await result[3].json();
      this.withholdings = await result[4].json();
      this.invoice_categories = await result[5].json();
      this.ncfTypes = await result[6].json();

      this.ncfTypes.unshift({ id: 0, name: "SIN COMPROBANTE" });
      this.credit_days = await result[7].json();
    },
    updateUrlAndLoadData() {
      this.updateUrl();
      this.loadAllData('d6');
    },

    syncStoreDateRange(dateStart = this.dateStart_filter, dateEnd = this.dateEnd_filter) {
      if (!dateStart || !dateEnd) {
        return;
      }
      this.$store.commit("setDateRange", {
        dateStart,
        dateEnd,
      });
    },

    applyRangeDates(rangeValue, isInitialLoad = false) {
      let dateStart = null;
      let dateEnd = null;

      const format = "YYYY-MM-DD";

      switch (rangeValue) {
        case "1": // Hoy
          dateStart = dateEnd = moment().format("YYYY-MM-DD");
          break;
        // case "2": // Ayer
        //   dateStart = dateEnd = moment().subtract(1, "day").format("YYYY-MM-DD");
        //   break;
        case "3": // Esta semana
          dateStart = moment().startOf("week").format("YYYY-MM-DD");
          dateEnd = moment().endOf("week").format("YYYY-MM-DD");
          break;
        case "4": // Este mes
          dateStart = moment().startOf("month").format("YYYY-MM-DD");
          dateEnd = moment().endOf("month").format("YYYY-MM-DD");
          break;
        case "5": // Últimos 3 meses
          dateStart = moment().subtract(3, "months").format("YYYY-MM-DD");
          dateEnd = moment().endOf("month").format("YYYY-MM-DD");
          break;
        case "6": // Este año
          dateStart = moment().startOf("year").format("YYYY-MM-DD");
          dateEnd = moment().endOf("year").format("YYYY-MM-DD");
          break;
        case "7": // Personalizado
          return; // No actualizar fechas automáticamente
        default:
          if (isInitialLoad && !this.dateStart_filter) {
            // Si es la carga inicial y no hay fecha en URL/Store, usar default "Este Mes"
            dateStart = moment().startOf("month").format(format);
            dateEnd = moment().endOf("month").format(format);
          }
          break;
      }

      if (dateStart && dateEnd) {
        // Solo actualizar si las fechas calculadas son diferentes, para evitar loops en watchers
        if (this.dateStart_filter !== dateStart || this.dateEnd_filter !== dateEnd) {
          this.dateStart_filter = dateStart;
          this.dateEnd_filter = dateEnd;
          this.syncStoreDateRange(dateStart, dateEnd);
        }
      }
    },

    collectMasterFilters() {
      return {
        business: this.business_filter,
        location: this.location_filter,
        dateStart: this.dateStart_filter,
        dateEnd: this.dateEnd_filter,
        rangeSelected: this.rangeSelected_filter,
      };
    },

    collectAllFilters() {
      if (
        this.lastFilters.dateStart != undefined &&
        (
          this.lastFilters.dateStart != this.dateStart_filter
          || this.lastFilters.dateEnd != this.dateEnd_filter
          || this.lastFilters.business != this.business_filter
          || this.lastFilters.location != this.location_filter
          || this.lastFilters.box_filter != this.box_filter
          || this.lastFilters.customer_filter != this.customer_filter
          || this.lastFilters.branche_filter != this.branche_filter
          || this.lastFilters.invoice_type != this.invoice_type
          || this.lastFilters.invoice_category != this.invoice_category
          || this.lastFilters.currency_filter != this.currency_filter
          || this.lastFilters.rangeSelected != this.rangeSelected_filter
        )
      ) {
        this.options.page = 1;
      }
      return {
        // Maestros
        business: this.business_filter,
        location: this.location_filter,
        dateStart: this.dateStart_filter,
        dateEnd: this.dateEnd_filter,
        rangeSelected: this.rangeSelected_filter,

        currency_filter: this.currency_filter,
        box_filter: this.box_filter,
        customer_filter: this.customer_filter,
        branche_filter: this.branche_filter,
        invoice_type: this.invoice_type,
        invoice_category: this.invoice_category,
      };
    },

    initializeFiltersFromStore() {
      const appState = this.$store.state.app;
      const mainFilters = appState.filters || {};
      const uiFilters = appState.invoiceSalesFilters || {};

      this.business_filter = mainFilters.business || 0;
      this.location_filter = mainFilters.location || 0;
      this.dateStart_filter = mainFilters.dateStart || this.dateStart_filter;
      this.dateEnd_filter = mainFilters.dateEnd || this.dateEnd_filter;
      this.rangeSelected_filter = appState.rangeSelected || "4";

      this.currency_filter = uiFilters.currency || 0;
      this.box_filter = uiFilters.box || 0;
      this.customer_filter = uiFilters.customer || 0;
      this.branche_filter = uiFilters.branch || -1;
      this.invoice_type = uiFilters.type || 0;
      this.invoice_category = uiFilters.category || 0;
      this.options.page = uiFilters.page || 1;
    },
    loadFiltersFromUrl() {
      const query = this.$route.query;
      let filtersFoundInUrl = false;

      const applyParam = (paramName, dataProp, isNumber = true) => {
        const value = query[paramName];
        if (value !== undefined) {
          const finalValue = isNumber ? (Number(value) || 0) : value;
          if (this[dataProp] !== finalValue) {
            this[dataProp] = finalValue;
            filtersFoundInUrl = true;
          }
        }
      };
      const page = this.$route.query.page;

      applyParam('business', 'business_filter');
      applyParam('locationGlobal', 'location_filter');
      applyParam('dateStart', 'dateStart_filter', false);
      applyParam('dateEnd', 'dateEnd_filter', false);
      applyParam('range', 'rangeSelected_filter', false);

      applyParam('currency', 'currency_filter');
      applyParam('box', 'box_filter');
      applyParam('customer', 'customer_filter');
      applyParam('branch', 'branche_filter');
      applyParam('type', 'invoice_type');
      applyParam('category', 'invoice_category');
      applyParam('limit', 'options.itemsPerPage');
      applyParam('page', 'options.page');
      this.options.page = page != undefined ? parseInt(page) : 1;
      return { filtersFoundInUrl };
    },
    updateUrl() {

      const query = {
        business: this.business_filter || undefined,
        locationGlobal: this.location_filter || undefined,
        dateStart: this.dateStart_filter || undefined,
        dateEnd: this.dateEnd_filter || undefined,
        range: this.rangeSelected_filter || undefined,

        currency: this.currency_filter || undefined,
        box: this.box_filter || undefined,
        customer: this.customer_filter || undefined,
        branch: this.branche_filter || undefined,
        type: this.invoice_type || undefined,
        category: this.invoice_category || undefined,

        page: this.options.page > 1 ? this.options.page : undefined,
        limit: this.options.itemsPerPage,
        sortBy: this.options.sortBy[0] || undefined,
        sortDesc: this.options.sortDesc[0] || undefined,
      };

      const cleanQuery = Object.fromEntries(
        Object.entries(query).filter(([key, v]) => {
          if (v === undefined || v === null || v === "") return false;
          if ((key === 'business' || key === 'locationGlobal') && v === 0) return true;
          if (['currency', 'box', 'customer', 'branch', 'type', 'category'].includes(key) && v === 0) return true;
          if (['range', 'dateStart', 'dateEnd', 'sortBy', 'sortDesc'].includes(key)) return true;

          return v !== 0;
        })
      );

      this.$router.replace({ query: cleanQuery }).catch(() => { });
    },
    async loadAllData(origin) {
      this.lastFilters = this.collectAllFilters();

      this.updateUrl();

      try {
        await Promise.all([
          this.getBoxFilters(this.lastFilters),
          this.getCustomerFilters(this.lastFilters)
        ]);
      } catch (error) {
        console.error("Error al cargar filtros base:", error);
      }

      // this.options.page = 1; 

      try {
        await Promise.all([
          this.loadInvoicesPaginada('d'),
          this.getGlobalTotals(),
          this.getBoxTotals(),
        ]);
      } catch (error) {
        console.error("Error en carga paralela de datos/reportes:", error);
      }
    },

    handleFilterUIChange() {
      this.lastFilters = this.collectAllFilters();

      //this.options.page = 1; 
      this.getGlobalTotals();
      this.getBoxTotals();
      this.loadInvoicesPaginada('a');
    },
    async loadInvoicesPaginada(origin) {

      if (this.loading || Object.keys(this.lastFilters).length === 0) {
        return;
      }
      try {
        this.invoices = [];
        this.loading = true;
        const filtersToSend = {
          ...this.lastFilters,
          users: this.user_group.length > 0 ? this.user_group.join(',') : null,
          page: this.options.page,
          limit: this.options.itemsPerPage,
          sortBy: this.options.sortBy[0],
          sortDesc: this.options.sortDesc[0],
        };

        let resultInvoices = await this.api_Post("income/invoice_resume_ssr", filtersToSend);
        if (resultInvoices.status == 200) {
          const result = await resultInvoices.json();
          this.invoice_counts = result.total || [];
          this.totalItems = result.total.reduce((acc, item) => {
            return acc + Number(item.total);
          }, 0);
          this.invoices = [];

          for (let item of result.data || []) {
            item.total_notes = this.currencyFormat(parseFloat(item.total_credits) - parseFloat(item.total_debits));
            this.invoices.push({ ...item, branch: item.branch == 'SIN SUCURSAL' ? 'N/A' : item.branch });
          }

          this.lastPaginationOptions = JSON.parse(JSON.stringify(this.options));
        }
      } catch (error) {
        console.error("Error al obtener facturas paginadas:", error.message);
        this.invoices = [];
        this.totalItems = 0;
      } finally {
        this.loading = false;
      }
    },
    async getCustomerFilters(data) {
      if (this.loadingCustomers) return;

      try {
        this.loadingCustomers = true;
        const filtersToSend = {
          ...data,
          invoice_type: this.lastFilters.invoice_type,
          users: this.user_group.length > 0 ? this.user_group.join(',') : null,
        };

        let result = await this.api_Post("income/customers-by-invoices", filtersToSend);
        if (result.status === 200) {
          const clientData = await result.json();
          let list = clientData.data || [];

          list.unshift({ text: "Todos", value: -1 });
          this.customerFilterList = list;

          if (!this.customerFilterList.some(c => c.value === this.customer_filter)) {
            this.customer_filter = -1;
          }
        }
      } catch (error) {
        console.error("Error al obtener lista de clientes:", error.message);
        this.customerFilterList = [{ text: "Todos", value: -1 }];
      } finally {
        this.loadingCustomers = false;
      }
    },
    async getBranchFilters(masterFilters, customerId) {
      if (!customerId || customerId === 0 || customerId === -1) {
        this.brancheFilterList = [{ text: "Todos", value: -1 }];
        this.branche_filter = -1;
        return;
      }

      try {
        const filtersToSend = {
          business: masterFilters.business,
          location: masterFilters.location,
          dateStart: masterFilters.dateStart,
          dateEnd: masterFilters.dateEnd,
          customer_id: customerId,
        };

        let result = await this.api_Post("income/branches-by-customer", filtersToSend);

        if (result.status === 200) {
          const branchData = await result.json();
          let list = branchData.data || [];

          list.unshift({ text: "Sin sucursal", value: 0 });
          list.unshift({ text: "Todos", value: -1 });
          this.brancheFilterList = list;

          if (!this.brancheFilterList.some(b => b.value === this.branche_filter)) {
            this.branche_filter = -1;
          }
        }
      } catch (error) {
        console.error("Error al obtener lista de sucursales:", error.message);
        this.brancheFilterList = [{ text: "Todos", value: -1 }];
        this.branche_filter = -1;
      }
    },
    async getBoxFilters(data) {
      if (this.loading_box_filter) {
        return
      }
      this.loading_box_filter = true;
      try {
        const filtersToSend = {
          business: data.business,
          location: data.location,
          dateStart: data.dateStart,
          dateEnd: data.dateEnd,
          invoice_type: this.lastFilters.invoice_type,
          users: this.user_group.length > 0 ? this.user_group.join(',') : null,
        };

        let result = await this.api_Post("income/boxes-by-invoices", filtersToSend);

        if (result.status === 200) {
          const boxData = await result.json();
          let list = boxData.data || [];

          list.unshift({ text: "Todas", value: 0 });
          this.boxFilterList = list;

          if (!this.boxFilterList.some(b => b.value === this.box_filter)) {
            this.box_filter = 0;
          }
        }
      } catch (error) {
        console.error("Error al obtener lista de cajas:", error.message);
        this.boxFilterList = [{ text: "Todas", value: 0 }];
        this.box_filter = 0;
      } finally {
        this.loading_box_filter = false;
      }
    },
    downloadPDF() { },
    showNew() {
      this.quotation_id = null;
      this.editedItem = {};
      this.editOrCopyStatus = false;
      this.dialog = true;
    },
    invoices_count(type) {
      if (this.invoice_counts.length == 0) {
        return 0;
      }
      const count = this.invoice_counts.find((element) => element.status_id === type);
      return count == undefined ? 0 : this.currencyFormat(count.total).split(".")[0];
    },
    async getGlobalTotals() {
      if (this.loadingTotals || Object.keys(this.lastFilters).length === 0) return;

      try {
        this.loadingTotals = true;

        const filtersToSend = {
          ...this.lastFilters,
          users: this.user_group.length > 0 ? this.user_group.join(',') : null,
        };

        let result = await this.api_Post("income/invoice-currency-totals", filtersToSend);

        if (result.status === 200) {
          const totalsData = await result.json();
          this.currencyTotals = totalsData.data || [];
        }
      } catch (error) {
        console.error("Error al obtener totales por moneda:", error.message);
        this.currencyTotals = [];
      } finally {
        this.loadingTotals = false;
      }
    },
    async getBoxTotals() {
      if (this.loadingBoxTotals || Object.keys(this.lastFilters).length === 0) return;

      try {
        this.loadingBoxTotals = true;

        const filtersToSend = {
          ...this.lastFilters,
          users: this.user_group.length > 0 ? this.user_group.join(',') : null,
        };

        let result = await this.api_Post("income/box-currency-totals", filtersToSend);

        if (result.status === 200) {
          const totalsData = await result.json();
          this.boxCurrencyTotals = totalsData.data || [];
        }
      } catch (error) {
        console.error("Error al obtener totales por caja:", error.message);
        this.boxCurrencyTotals = [];
      } finally {
        this.loadingBoxTotals = false;
      }
    },
    // Lógica para actualizar Locations cuando cambia el Business
    updateLocationsForBusiness() {
      // (Lógica del componente anterior para filtrar itemsLocations2)
      const allLocations = this.$store.state.auth.locations || [];
      const busId = this.business_filter;

      this.locations = allLocations
        .filter(loc => busId === 0 || loc.bus_id === busId)
        .map(loc => ({ text: loc.text, value: loc.value }));

      this.locations.unshift({ text: "Todas", value: 0 });

      // Validar si la selección actual es válida en la nueva lista, si no, resetear a 0.
      const currentSelectedValue = this.location_filter;
      const isValid = this.locations.some(loc => loc.value === currentSelectedValue);

      if (!isValid) {
        this.location_filter = 0;
      }
    },
    async save_csv(report_type) {
      if (this.loading) {
        return;
      }

      // 1. Recopilar filtros (usamos lastFilters que está actualizado)
      const filtersToSend = {
        ...this.lastFilters,
        users: this.user_group.length > 0 ? this.user_group.join(',') : null,
        report_type: report_type, // Indica al backend qué reporte generar
      };

      try {
        this.loading = true;

        // El backend debe manejar la generación del CSV.
        let response = await this.api_Post("income/invoice_export_csv", filtersToSend);

        if (response.status === 200) {
          const result = await response.json();
          const csvData = result.csv_data;
          const fileName = result.file_name;

          if (csvData) {
            this.generateCsvFile(fileName, csvData);
          } else {
            alert("No se encontraron facturas para generar el reporte.");
          }
        } else {
          alert(`Error al generar el reporte: ${response.statusText}`);
        }

      } catch (error) {
        console.error("Error en save_csv:", error.message);
        alert("Ocurrió un error al intentar descargar el reporte.");
      } finally {
        this.loading = false;
      }
    },
    clear() {
      this.editedItem = null;
      this.dialog = false;
    },
    async editItem(item, type) {
      this.editOrCopyStatus = true;
      this.quotation_id = null;
      const responseRequest = await this.api_Post("income/search_invoice_id", {
        number: item.invoice_id,
      });

      if (responseRequest.status == 200) {
        let invoice = await responseRequest.json();

        this.editedItem = Object.assign({}, invoice[0]);
        this.editedItem.is_editing = true;
        this.editedItem.nota = this.editedItem.note;

        let data = this.editedItem;
        if (type === true) {
          data.invoice_id = 0;
        }
      }

      this.dialog = true;
    },
    async loadUserFilters() {
      if (this.loading_search_invoice) return;

      try {
        this.loading_search_invoice = true;
        const filtersToSend = this.collectAllFilters();

        let result = await this.api_Post("income/invoice_users_filter", filtersToSend);

        if (result.status === 200) {
          const userData = await result.json();
          let list = userData.data || [];

          this.users = list;
        }
      } catch (error) {
        console.error("Error al obtener lista de usuarios:", error.message);
        this.users = [{ text: "Todos", value: 0 }];
        alert("Error al cargar la lista de usuarios.");
      } finally {
        this.loading_search_invoice = false;
        this.dialog_settings = true;
      }
    },
    // type: 1 = invoice_number (No. Factura), 2 = invoice_ncf (Comprobante / NCF)
    async find_invoice(type = 1) {
      try {
        this.loading_search_invoice = true;

        const location_access = this.itemsLocations.map((i) => i.id);
        if (location_access.length === 0) {
          this.$toast.error("No hay localidades disponibles para buscar");
          this.loading_search_invoice = false;
          return;
        }

        if (!this.business_filter || this.business_filter === 0) {
          this.$toast.error("Selecciona una Unidad de Negocio antes de buscar (cada unidad tiene su propia secuencia de NCF)");
          this.loading_search_invoice = false;
          return;
        }

        const sanitize = (v) => (v == null ? "" : v.toString().replaceAll("'", "").replaceAll("%", "").trim());

        let term = "";
        let whereClause = "";
        if (type == 1) {
          term = sanitize(this.search_invoice);
          whereClause = term ? `INVOICE_NUMBER ILIKE '%${term}%'` : "";
        } else if (type == 2) {
          term = sanitize(this.search_invoice_with_ncf);
          whereClause = term ? `INVOICE_NCF ILIKE '%${term}%'` : "";
        } else {
          this.$toast.error("Tipo de búsqueda no válido");
          this.loading_search_invoice = false;
          return;
        }

        if (!term) {
          this.$toast.error("Búsqueda no válida: ingrese al menos un carácter");
          this.loading_search_invoice = false;
          return;
        }

        // Scope obligatorio por unidad de negocio: cada BU emite su propia secuencia de NCF,
        // así que sin este filtro se cruzan facturas con eNCFs idénticos entre unidades distintas.
        const query =
          `WHERE ${whereClause}` +
          ` AND INVOICES.BUSINESS_UNIT_ID = ${parseInt(this.business_filter)}` +
          ` AND INVOICES.LOCATION_ID IN (${location_access.join(",")})`;

        const responseRequest = await this.api_Post("income/invoice_sales_list", { filters: query });

        if (responseRequest.status != 200) {
          this.$toast.error("Error al consultar la factura");
          this.loading_search_invoice = false;
          return;
        }

        const invoice = await responseRequest.json();
        if (!invoice || invoice.length === 0) {
          this.$toast.info("Factura no encontrada!");
          this.invoices_found = [];
          this.loading_search_invoice = false;
          return;
        }

        this.invoices_found = invoice;
        this.loading_search_invoice = false;
      } catch (error) {
        console.error(error.message);
        this.$toast.error(error.message);
        this.loading_search_invoice = false;
      }
    },

    clearInvoiceSearch() {
      this.search_invoice = null;
      this.search_invoice_with_ncf = null;
      this.invoices_found = [];
    },

    onSearchInputChange(field) {
      if (field === "invoice") {
        this.search_invoice_with_ncf = null;
      } else if (field === "ncf") {
        this.search_invoice = null;
      }
    },
    clearUiFilters() {
      this.currency_filter = 0;
      this.box_filter = 0;
      this.customer_filter = 0;
      this.branche_filter = -1;
      this.invoice_type = 0;
      this.invoice_category = 0;
      this.user_group = [];
      this.search = null;

      this.updateUrl();
      this.loadAllData();
    },
    cancel_user_filters() {
      this.user_group = [];
      this.loadAllData('d9')
      this.dialog_settings = false;
    },
    async save(data) {
      this.loadingSave = true;

      this.loadAllData('z');

      this.showInvoice(data[0].id, true);
      this.dialog = false;

      this.loadingSave = false;
    },
  },
};
</script>

<style scoped>
.selection-bar {
  background: rgba(25, 118, 210, 0.08);
}

/* ===================================
   DISEÑO MODERNO Y LIMPIO
   =================================== */

/* Tabla moderna */
::v-deep .modern-table tbody tr {
  transition: all 0.2s ease;
}

::v-deep .modern-table tbody tr:hover {
  background-color: #f5f5f5 !important;
}

::v-deep .modern-table thead th {
  font-weight: 600 !important;
  color: #424242 !important;
  background-color: #fafafa !important;
}

/* Cards con hover sutil */
.currency-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 8px !important;
}

.currency-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

/* Filas de tabla con hover */
.table-row {
  transition: background-color 0.2s ease;
}

.table-row:hover {
  background-color: #fafafa !important;
}

/* Chips modernos */
::v-deep .v-chip {
  font-weight: 500;
  letter-spacing: 0.25px;
}

/* Botones con efecto sutil */
::v-deep .v-btn {
  transition: all 0.2s ease;
  text-transform: none !important;
  letter-spacing: 0.25px;
}

::v-deep .v-btn:hover:not(.v-btn--disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Inputs con bordes suaves */
::v-deep .v-text-field--outlined fieldset,
::v-deep .v-select--outlined fieldset,
::v-deep .v-autocomplete--outlined fieldset {
  border-color: #e0e0e0 !important;
  transition: border-color 0.2s ease;
}

::v-deep .v-text-field--outlined:hover:not(.v-input--is-disabled) fieldset,
::v-deep .v-select--outlined:hover:not(.v-input--is-disabled) fieldset,
::v-deep .v-autocomplete--outlined:hover:not(.v-input--is-disabled) fieldset {
  border-color: #bdbdbd !important;
}

::v-deep .v-text-field--outlined.v-input--is-focused fieldset,
::v-deep .v-select--outlined.v-input--is-focused fieldset,
::v-deep .v-autocomplete--outlined.v-input--is-focused fieldset {
  border-width: 2px !important;
}

/* Paginación limpia */
::v-deep .v-pagination__item {
  transition: all 0.2s ease;
  box-shadow: none !important;
}

::v-deep .v-pagination__item:hover {
  background-color: #f5f5f5 !important;
}

::v-deep .v-pagination__item--active {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

/* Progress bar suave */
::v-deep .v-progress-linear {
  border-radius: 4px;
}

/* Tooltips modernos */
::v-deep .v-tooltip__content {
  background: rgba(33, 33, 33, 0.95) !important;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 13px;
}

/* Skeleton loader */
::v-deep .v-skeleton-loader__bone {
  background-size: 200% 100%;
  animation: loading 1.5s ease-in-out infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }

  100% {
    background-position: -200% 0;
  }
}

/* Badge sutil */
::v-deep .v-badge__badge {
  font-weight: 600;
  font-size: 11px;
}

/* Scroll suave */
::v-deep .v-data-table__wrapper {
  scroll-behavior: smooth;
}

/* Cards con bordes suaves */
::v-deep .v-card {
  border-radius: 8px !important;
}

/* Dividers sutiles */
::v-deep .v-divider {
  border-color: #e0e0e0 !important;
}

/* Iconos con transición */
::v-deep .v-icon {
  transition: color 0.2s ease;
}

/* Menu items hover */
::v-deep .v-list-item:hover {
  background-color: #f5f5f5 !important;
}

/* Mejora de accesibilidad */
::v-deep .v-btn:focus::before,
::v-deep .v-chip:focus::before {
  opacity: 0.08;
}
</style>